<template>
    <span id="counsellor-view">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-action btn-primary btn-sm mr-2 mb-2" data-toggle="modal"
            :data-target="getDataTarget()"><i class="fas fa-info-circle"></i></button>

        <!-- Modal -->
        <div class="modal fade text-left" :id="getModalId()" tabindex="-1" aria-labelledby="counsellorViewLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="counsellorViewLabel">View Counsellor</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form :id="getFormId()" @submit.prevent>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="givenName">First Name</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="givenName"
                                            name="givenName" v-model="counsellor.givenName" aria-describedby="givenName"
                                            placeholder="Not available">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="surname">Last Name</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="surname"
                                            name="surname" v-model="counsellor.surname" aria-describedby="surname"
                                            placeholder="Not available">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="role">Role</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="role"
                                            name="role" v-model="counsellor.role" aria-describedby="role"
                                            placeholder="Not available">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="office">Office</label>
                                        <input type="text" class="form-control form-control-sm" disabled id="office"
                                            name="office" v-model="counsellor.office" aria-describedby="office"
                                            placeholder="Not assigned">
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <label for="waitingArea">Waiting Area</label>
                                    <input type="text" class="form-control form-control-sm" disabled id="role"
                                        name="role" v-model="counsellor.waitingArea" aria-describedby="role"
                                        placeholder="Not assigned">
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="zoomLink">Zoom Link</label>
                                        <div v-if="counsellor.zoomLink">
                                            <a :href="counsellor.zoomLink" target="_blank">{{ counsellor.zoomLink }}</a>
                                        </div>
                                        <input v-else type="text" class="form-control form-control-sm" disabled
                                            id="role" name="role" v-model="counsellor.zoomLink" aria-describedby="role"
                                            placeholder="None">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    name: 'counsellors-view',
    props: {
        counsellor: {
            required: true,
            type: Object
        }
    },
    methods: {
        getDataTarget() {
            return `#counsellorView-${this.counsellor.id}`;
        },
        getFormId() {
            return `counsellorViewForm-${this.counsellor.id}`;
        },
        getModalId() {
            return `counsellorView-${this.counsellor.id}`;
        }
    }
}
</script>